import React from "react";
import styles from "./MyNetworkCard.module.css";
import { MdGroups } from "react-icons/md";

interface MyNetworkCardProps {
  direct: number;
  indirect: number;
  userName: string;
}

export const MyNetworkCard: React.FC<MyNetworkCardProps> = ({
  direct,
  indirect,
  userName
}) => {
  return (
      <div className="card max-w-lg w-full">
        <div className="mb-4 p-2 border-2 border-primary rounded-full">
          <MdGroups size={30} className="text-primary" />
        </div>
        <h1 className="text-2xl font-bold mb-4 text-center">Mi red</h1>
        <p className="text-gray-500 text-center mb-6">
          Hola {userName} aquí puedes ver el resumen de tu red de referidos.
        </p>
        <div className="bg-[#fbd38c] p-8 w-full rounded-lg flex items-center flex-col">
          <h2 className="font-bold mb-3 text-[#102638]">Total de referidos</h2>
          <div className="flex gap-4">
            <div className="flex flex-col items-center bg-white shadow-md rounded-lg overflow-hidden w-24 md:w-32">
              <span className={styles.count}>{direct}</span>
              <span className="bg-primary text-white text-sm font-bold p-2 w-full text-center">
                Directos
              </span>
            </div>
            <div className="flex flex-col items-center bg-white shadow-md rounded-lg overflow-hidden w-24 md:w-32">
              <span className={styles.count}>{indirect}</span>
              <span className="bg-primary text-white text-sm font-bold p-2 w-full text-center">
                Indirectos
              </span>
            </div>
          </div>
        </div>
      </div>
  );
};
